import './instrumentation'

import { Stylesheets } from '@mono-activities/ui'
import { R2WCBaseProps } from '@r2wc/core'
import reactToWebComponent from '@r2wc/react-to-web-component'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App, { AppProps } from '@/App'
import appStyle from '@/index.css?inline'
import styleFonts from '@/styles/fonts.css?inline'

// RENDER THE APP FOR DEVELOPMENT
const root = document.getElementById('root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <Stylesheets css={appStyle} />
      <App />
    </StrictMode>
  )
}

// CREATE THE WEB COMPONENT
const styledApp = (webComponentProps: AppProps & R2WCBaseProps) => {
  const addFontFaceToPage = () => {
    const styleTag = document.createElement('style')
    styleTag.appendChild(document.createTextNode(styleFonts))
    document.getElementsByTagName('head')[0].appendChild(styleTag)
  }
  addFontFaceToPage()

  // extract app props from reactTowebComponent props
  const props = {
    ...(webComponentProps.locale && { locale: webComponentProps.locale }),
    ...(webComponentProps.userId && { userId: webComponentProps.userId }),
    ...(webComponentProps.backUrl && { backUrl: webComponentProps.backUrl }),
    ...(webComponentProps.persona && { persona: webComponentProps.persona }),
    ...(webComponentProps.relationship && { relationship: webComponentProps.relationship }),
    ...(webComponentProps.interestedBy && { interestedBy: webComponentProps.interestedBy }),
  }

  return (
    <>
      <Stylesheets css={appStyle} />
      <App {...props} />
    </>
  )
}

customElements.define(
  'tme-app',
  reactToWebComponent(styledApp, {
    shadow: 'closed',
    props: {
      locale: 'string',
      userId: 'string',
      backUrl: 'string',
      persona: 'string',
      relationship: 'string',
      interestedBy: 'string',
    },
  })
)
